import React from 'react';
import { Helmet } from 'react-helmet-async';

const TabTitle = ({title}) => {
    return (
        <div>
            <Helmet>
                <title>{`${title}`}</title>
                <link rel="icon" type="image/png" href="../assets/logos/sidebar-logo.png" />
            </Helmet>
        </div>
    )
}

export default TabTitle